export default __webpack_public_path__ + "static/media/hacemos_background.65f69e54.png";